module.exports = __webpack_public_path__ + "054a4802174ac40068f4e6f0ad426fe0.png";